/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import './login.scss';

import LoginRoutes from './login.routes';
import LoginController from './login.controller';
import ResetPasswordRequestController from './reset-password-request.controller';
import ResetPasswordController from './reset-password.controller';
import CreatePasswordController from './create-password.controller';
import RedirectPageController from './redirect-page.controller';

export default angular.module('tektelic.login', [])
    .config(LoginRoutes)
    .controller('LoginController', LoginController)
    .controller('RedirectPageController', RedirectPageController)
    .controller('ResetPasswordRequestController', ResetPasswordRequestController)
    .controller('ResetPasswordController', ResetPasswordController)
    .controller('CreatePasswordController', CreatePasswordController)
    .name;



// WEBPACK FOOTER //
// ./src/app/login/index.js